<template>
  <b-form-group :id="id">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8">
        <div class="d-flex justify-content-between">
          <b-form-radio
            v-for="option in options"
            :key="option.id"
            v-model="selected"
            :name="option.text.toString()"
            :value="option.value"
            button
            button-variant="outline-secondary"
            class="text-center"
            v-b-tooltip.hover
            :title="option.tooltip"
            @change="optionSelected"
          >
            {{ option.text }}
          </b-form-radio>
        </div>
      </div>
    </div>
  </b-form-group>
</template>

<script>
export default {
  name: "RatingPrompt",
  props: {
    id: String,
    answers: Array,
    currentOption: Number,
  },
  data() {
    return {
      selected: this.currentOption,
    };
  },
  methods: {
    optionSelected(option) {
      this.$emit("optionSelected", { answers: option });
    },
  },
  computed: {
    options() {
      return this.answers.map((answer, index) => {
        return { text: index + 1, value: answer.id, tooltip: answer.text };
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .btn-group-toggle {
  .btn-outline-secondary {
    border-radius: 50% !important;
    width: 42px !important;
    height: 42px !important;
    line-height: 28px !important;
  }
}
</style>
